import { render } from "./radio-buttons.vue?vue&type=template&id=3d6aab36&ts=true"
import script from "./radio-buttons.vue?vue&type=script&lang=ts"
export * from "./radio-buttons.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__